import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
@Pipe({
    name: 'CustomCalendarWeeklyDatePipe'
})
export class CustomCalendarWeeklyDatePipe implements PipeTransform {
    transform(value: Date): string {
        const startDate = dayjs(value);
        const endDate = startDate.add(6, 'day');
        const formattedStartDate = startDate.format('DD MMM YYYY');
        const formattedEndDate = endDate.format('DD MMM YYYY');
        return `${formattedStartDate} - ${formattedEndDate}`;
    }
}